module.exports = __webpack_public_path__ + "static/img/knowledge2.aac42357.png";